<template>
    <div class="downloadCenter">
      <!--pc端-->
      <div class="pc-comp">
        <div class="flex content">
        <div class="left">
          <div
            v-for="(item, i) in categoryData"
            :key="i"
            @mouseover="onClick(item, i)"
            class="left-title flex-center"
            :class="isActiveI == i ? 'is-active' : ''"
          >
            <span>{{ item.categoryName }}</span>
          </div>
        </div>
        <div class="right">
          <ul class="news-ul-li" style="height: 420px">
            <li
              class="space-between"
              v-for="(item, i) in listData"
              :key="i"
              @click="toDetails(
                {
                  id: item.id,
                  title: '公众服务',
                  tag: currentTag
                },
                item.linkTo
              )"
            >
              <p class="text_overflow" :title="item.title">{{ item.title }}</p>
              <span>{{
                item.publishedDate
                  ? item.publishedDate.split(' ')[0]
                  : item.createdDate.split(' ')[0]
              }}</span>
            </li>
          </ul>
          <div class="pagination" style="justify-content: center">
            <el-pagination
               @size-change="(val) => handlePagination('size', val, i)"
              @current-change="(val) => handlePagination('page', val, i)"
              :current-page="params.page"
              :page-sizes="[10, 20, 50, 60]"
              :page-size="params.size"
              layout="total, sizes, prev, slot, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </div>
      </div>

      <!--移动端-->
      <div class="mobile-comp">
        <div class="doc-box">
          <el-collapse v-model="activeNames" class="mobile-collapse">
            <el-collapse-item
              v-for="(item, i) in categoryData"
              :key="i"
              :title="item.categoryName"
              :name="i"
            >
            <div v-if="activeNames.includes(i)">
              <ul class="news-ul-li" style="height: 420px">
                <li
                  class="space-between"
                  v-for="(article, j) in mobileListData[i] || []"
                  :key="j"
                  @click="
                    toDetails(
                      {
                        id: article.id,
                        title: '公众服务',
                        tag: currentTag
                      },
                      article.linkTo
                    )
                  "
                >
                  <p class="text_overflow" :title="item.title">
                    {{ article.title }}
                  </p>
                  <span>{{
                    article.publishedDate
                      ? article.publishedDate.split(' ')[0]
                      : article.createdDate.split(' ')[0]
                  }}</span>
                </li>
              </ul>
              <div class="pagination" style="justify-content: center">
                <el-pagination
                  @size-change="(val) => handlePagination('size', val, i)"
                  @current-change="(val) => handlePagination('page', val, i)"
                  :current-page="mobileParams[i]?.page || 0"
                  :page-sizes="[10, 20, 50, 60]"
                  :page-size="mobileParams[i]?.size || 10"
                  layout="total, sizes, prev, slot, pager, next, jumper"
                  :total="mobileTotal[i] || 0"
                  background
                >
                  <span class="slot">
                    {{ (mobileParams[i]?.page || 0) + 1 }}/{{ Math.ceil((mobileTotal[i] || 0) / 15) }}
                  </span>
                </el-pagination>
              </div>
            </div>
              
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { getArticleList, getKey } from '@/api/index'
  
  export default {
    data() {
      return {
        categoryData: [],
        // 移动端每个分类的数据
        mobileListData: {},
        // 移动端每个分类的分页参数
        mobileParams: {},
        // 移动端每个分类的总数
        mobileTotal: {},
        // 区分PC端和移动端 
        isMobile: false,
        isActiveI: 0,
        listData: [],
        params: {
          page: 0,
          size: 10
        },
        total: 0,
        activeNames: [0],
        currentTag: this.$route.query.tag
      }
    },
    watch: {
      activeNames: {
        handler(newVal) {
          if (!this.categoryData || this.categoryData.length === 0) return
          
          newVal.forEach(index => {
            if (this.categoryData[index] && !this.mobileListData[index]) {
              this.getArticleList(this.categoryData[index].key, index)
            }
          })
        },
        immediate: true
      },
      // 监听路由参数的变化
      '$route.query.tag': {
        handler(newVal) {
          this.currentTag = newVal;
          this.getData(); // 重新获取数据
        },
        immediate: true
      }
  },
    methods: {
       // 点击分类
      onClick(item, i) {
        this.isActiveI = i
        this.getArticleList(item.key)
      },
      // 获取下载中心、常见问题分类
      getData() {
        const key = 'service.id'
        getKey({ key: key }).then((res) => {
          if (res) {   
            // 找到配置项
            const configItem = res.children.find(
              item => item.name === this.currentTag
            )
            
            if (configItem) {
              // 获取下载中心、常见问题子项数据
              getKey({ key: configItem.configKey }).then(childRes => {
                if (childRes && childRes.children) {
                  this.categoryData = childRes.children.map(item => ({
                    categoryName: item.name,
                    key: item.configKey
                  }))
                  // 初始化移动端数据
                  this.categoryData.forEach((item, index) => {
                    this.$set(this.mobileParams, index, { page: 0, size: 10 })
                    this.$set(this.mobileTotal, index, 0)
                  })
                  
                  if (this.categoryData.length > 0) {
                    if (this.isMobile) {
                      this.getArticleList(this.categoryData[0].key, 0)
                    } else {
                      this.onClick(this.categoryData[0], 0)
                    }
                  }
                } else {
                  this.categoryData = []
                }
              })
            } else {
              this.categoryData = []
            }
          } else {
            this.categoryData = []
          }
        }).catch(err => {
          console.error('Failed to get key:', err)
          this.categoryData = []
        })
      },

      // 获取下载中心、常见问题的文章列表
      getArticleList(key, index = null) {
        const params = index !== null 
          ? {
              page: this.mobileParams[index]?.page || 0,
              size: this.mobileParams[index]?.size || 10,
              key: key
            }
          : {
              page: this.params.page,
              size: this.params.size,
              key: key
            }

        getArticleList(params).then((res) => {
          // 移动端
          if (index !== null) {
            this.$set(this.mobileTotal, index, res.count)
            this.$set(this.mobileListData, index, res.list)
          } else {
            this.total = res.count
            this.listData = res.list
          }
        })
      },
      // 处理分页
      handlePagination(type, val, index = null) {
        if (index !== null) {
          // 移动端分页处理
          this.$set(this.mobileParams, index, {
            ...this.mobileParams[index],
            page: type === 'size' ? 0 : val - 1,
            size: type === 'size' ? val : this.mobileParams[index]?.size || 10
          })
          this.getArticleList(this.categoryData[index].key, index)
        } else {
          // PC端分页处理
          this.params = {
            ...this.params,
            page: type === 'size' ? 0 : val - 1,
            size: type === 'size' ? val : this.params.size
          }
          this.getArticleList(this.categoryData[this.isActiveI].key)
        }
      },
      toDetails(query, linkTo) {
        if (linkTo) {
          window.open(linkTo, '_blank')
        } else {
          this.$router.push({ path: '/details', query })
        }
      }
    },
    mounted() {
      // 是否移动端
      this.isMobile = window.innerWidth <= 768 
        if (this.categoryData.length > 0) {
        this.getArticleList(this.categoryData[0].key)
      }
    }
  }
  </script>
  // ... existing code ...

<style lang="scss" scoped>
.downloadCenter {
  height: 580px;
}
.content {
  width: 100%;
  background: url(../../assets/images/back.webp) no-repeat;
  background-size: 100% 100%;
  padding: 20px 0 20px;
  
  .left {
    height: 100%;
    overflow: auto;
    min-width: 246px;
    
    .left-title {
      height: 45px;
      width: 217px;
      background: #e4edfa;
      margin-bottom: 2px;
      text-align: center;
      font-weight: 400;
      font-size: 18px;
      color: #1e1e1e;
      cursor: pointer;
      position: relative;
      padding: 0 12px;
    }
    
    .is-active {
      background: #1b6ad2;
      color: #fff;
    }
    
    .is-active::after {
      content: '';
      height: 45px;
      position: absolute;
      display: block;
      top: 0;
      right: -23px;
      width: 0px;
      height: 0px;
      border-top: 23px solid transparent;
      border-bottom: 22px solid transparent;
      border-left: 23px solid #1b6ad2;
      z-index: 4;
    }
  }
  
  .right {
    width: 100%;
    margin: 45px 26px 45px 20px;
    overflow: auto;
    
    .news-ul-li {
      background: none;
      overflow-y: scroll;
      padding: 0px 40px 20px;
      margin-bottom: 16px;
      
      li {
        min-height: 47px;
        border-bottom: 1px solid #14579e;
        cursor: pointer;

        &:hover {
          p {
            color: #14579e;
            font-weight: 600;
            transform: scale(1.01);
          }
          span {
            font-weight: normal;
          }
        }
        
        p {
          font-size: 18px;
          color: #131414;
          line-height: 40px;
          transition: all 0.3s;
        }
        
        span {
          font-size: 18px;
          line-height: 40px;
          width: 116px;
          color: #888888;
          display: inline-block;
          font-weight: normal;
        }
      }
    }
  }
}
.doc-box {
  ::v-deep .el-collapse-item__header {
    height: 32px;
    background-color: #e4edfa;
    padding-left: 16px;
    font-size: 14px;
    border-radius: 4px;
  }
  ::v-deep .el-collapse-item {
    margin-top: 16px;
  }
  ::v-deep .el-collapse-item__content {
    font-size: 14px;
    padding: 16px;
  }
  ::v-deep .el-collapse-item__header.is-active {
    font-weight: bold;
    font-size: 14px;
    color: #1b6ad2;
    line-height: 22px;
  }
  ::v-deep .el-collapse-item__arrow {
    margin-right: 16px;
  }
  ::v-deep .el-icon-arrow-right:before {
    content: '\25b2';
    font-size: 14px;
  }
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(180deg);
  }
}

@media screen and (max-width: 768px) {
  .downloadCenter {
    height: auto;
  }
  
  .content {
    flex-direction: column;
    
    .left {
      width: 100%;
      min-width: auto;
      margin-bottom: 20px;
      
      .left-title {
        width: 100%;
      }
    }
    
    .right {
      margin: 0;
      width: 100%;
      
      .news-ul-li {
        padding: 0 20px;
        
        li {
          p, span {
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>